var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.48226 12.9997C3.60486 12.9997 3.72745 12.9545 3.82424 12.8578L12.8577 3.82576C13.0448 3.63867 13.0448 3.329 12.8577 3.14191C12.6706 2.95481 12.3609 2.95481 12.1737 3.14191L3.14028 12.1739C2.95316 12.361 2.95316 12.6707 3.14028 12.8578C3.23707 12.9545 3.35966 12.9997 3.48226 12.9997Z",
    fill: "#6374FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5161 10.5933C12.7806 10.5933 13 10.374 13 10.1095V3.48386C13 3.21935 12.7806 3 12.5161 3H5.88937C5.62482 3 5.40544 3.21935 5.40544 3.48386C5.40544 3.74837 5.62482 3.96772 5.88937 3.96772H12.0321V10.1095C12.0321 10.374 12.2515 10.5933 12.5161 10.5933Z",
    fill: "#6374FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.fd27b82f8694fc5287220a45d4362a9d.svg";
export { ForwardRef as ReactComponent };